var React = require('react');

function Duration (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"streamline-icon-time-clock-circle_140x140_1_","data-name":"streamline-icon-time-clock-circle@140x140(1)","transform":"translate(-2.411 -2.422)"},[React.createElement("path",{"id":"Path_185","data-name":"Path 185","d":"M2.911,8.538A5.615,5.615,0,1,0,8.526,2.923,5.615,5.615,0,0,0,2.911,8.538Z","transform":"translate(0)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Path_186","data-name":"Path 186","d":"M70,37.922v2.686l2.93,2.686","transform":"translate(-61.473 -32.07)","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":1})]));
}

Duration.defaultProps = {"width":"12.23","height":"12.23","viewBox":"0 0 12.23 12.23"};

module.exports = Duration;

Duration.default = Duration;
